export default __webpack_public_path__ + "static/media/direction-alt.9714cf56.svg";